import { css } from '@emotion/react'

import * as styles from '@twisto/styles'

export const container = css`
  display: flex;
  justify-content: center;
  margin-top: ${styles.size[12]};
`

export const box = css`
  margin-top: ${styles.size[12]};
  padding: ${styles.size[8]} ${styles.size[16]};
  width: 100%;
`
